import { Directive, ViewContainerRef } from '@angular/core';
import { AppLayoutDefaultService } from './default.service';

@Directive({
  selector: '[appLayoutDefaultSide]',
})
export class AppLayoutDefaultSideDirective {
  constructor(
    public viewContainerRef: ViewContainerRef,
    private _appLayoutDefault: AppLayoutDefaultService,
  ) {
    this._appLayoutDefault.sideContainer = this;
  }
}
